"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Application from foundation/Application
 * @trackcomponent
 */
export const WriteOrderIcon = createSVGIcon(
  <>
    <rect
      x="0.5"
      y="3.16667"
      width="14.4459"
      height="15"
      rx="0.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.37878 6.83333H10.1363"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.37878 9.25H7.24025"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.37878 11.5417H7.24025"
      stroke="currentColor"
      strokeMiterlimit="16"
      strokeLinecap="round"
    />
    <path
      d="M10.122 12.4826L16.9922 4.85873L18.9855 6.66654L12.385 14.3411L9.01009 16.2662L10.122 12.4826Z"
      fill="white"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </>,
  "Write Order",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    titleAccess: "Write Order",
  }
);
